export const STATUS_MAP = {
  pending: { label: "In attesa", cls: "bg-amber-100 text-amber-700 border-amber-200" },
  accepted: { label: "Accettata", cls: "bg-green-100 text-green-700 border-green-200" },
  rejected: { label: "Rifiutata", cls: "bg-red-100 text-red-700 border-red-200" },
};

export const StatusBadge = ({ status }) => {
  const s = STATUS_MAP[status] || STATUS_MAP.pending;
  return (
    <span
      data-testid={`status-${status}`}
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border ${s.cls}`}
    >
      {s.label}
    </span>
  );
};
